import _ from 'lodash';

import template from './template.html';

function ToggleBtnDirective() {
  return {
    restrict: 'E',
    replace: true,
    template,
    require: 'ngModel',
    scope: {
      trueLabel: '@',
      trueClass: '@',
      falseLabel: '@',
      width: '@',
      onChange: '=?',
      onChanged: '=?',
      className: '=?'
    },
    link(scope, element, attrs, ngModelCtrl) {
      scope.trueLabel = scope.trueLabel || null;
      scope.falseLabel = scope.falseLabel || null;

      scope.onChange = _.isFunction(scope.onChange) ? scope.onChange : ((newValue, cb) => {
        return cb(true);
      });
      scope.onChanged = _.isFunction(scope.onChanged) ? scope.onChanged : (() => {});

      if (ngModelCtrl) {
        ngModelCtrl.$formatters.push(modelValue => {
          scope.value = modelValue;
        });
      }

      scope.toggle = function () {
        const newValue = !scope.value;

        scope.onChanged();

        scope.onChange(newValue, changedValue => {
          if (changedValue) {
            scope.value = newValue;

            if (ngModelCtrl) {
              ngModelCtrl.$setViewValue(scope.value);
              ngModelCtrl.$dirty = true;
            }
          }
        });
      };
    }
  };
}

ToggleBtnDirective.$inject = [];

export default ToggleBtnDirective;



// WEBPACK FOOTER //
// ./src/directives/toggleBtn/index.js